import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import React, {useContext, useEffect, useState} from "react";
import {addToCart, addtoWaitlist, getInventoryEvent} from "../../common/api/PortalCustomerApi";
import {AppContext} from "../../../lib/AppContext";
import {UserContext} from "../../../lib/UserProvider";
import {CartContext} from "../../../lib/CartProvider";
import {Modal} from "react-bootstrap";
import Loading from "../../common/Loading";
import RegisterEventModal from "../modal/RegisterEventModal";
import PreRegisterMemberOnlyEventModal from "../modal/PreRegisterMemberOnlyEventModal";
import EventDetail from "./EventDetail";
import {displayEventTime, timeBlockEvent, validEvent} from "../../common/Utils";
import {CompanyContext} from "../../../lib/CompanyProvider";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import {useConfirm} from "../../common/Confirmation";
import {InfoOutlined} from "@mui/icons-material";

export default function EventRegistration({event, embedded, callback, full, showRegistration}) {
  const [context, setContext] = useContext(AppContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [loggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    setLoggedIn(userContext?.sessionUser?.guid?.length > 0);
  }, [userContext]);

  const [viewCalendarEventDetail, setViewCalendarEventDetail] = useState(false);
  const [calendarEventDetail, setCalendarEventDetail] = useState();
  const [inventoryEvent, setInventoryEvent] = useState();
  const [showRegister, setShowRegister] = useState(false);
  const [showPreRegister, setShowPreRegister] = useState(false);

  const handleCloseCalendarEventDetail = () => {
    setViewCalendarEventDetail(false)
    setCalendarEventDetail(null);
  }

  const showSessionChildRegistration = (event) => {
    if (event.parentSessionEventDate) {
      let tempEvent = {
        allDay: event.allDay,
        eventDate: event.parentSessionEventDate
      }
      return validEvent(tempEvent);
    }
    return false;
  }

  const hideSessionRegistration = (event) => {
    return event.childSessionEvent;
  }
  const viewParentSessionEvent = (guid) => {
    setViewCalendarEventDetail(true);
    getInventoryEvent(guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCalendarEventDetail(result);
      }
    });
  }

  const hideTimeBlockRegistration = (event) => {
    return event?.timeBlockEvents?.length > 0;
  }

  const addToWaitlistFn = async (e) => {
    if (!userContext?.sessionUser?.guid) {
      setUserContext({...userContext, showLogin: true});
      return;
    }
    addtoWaitlist(e).then(resp => {
      setCartContext({...cartContext, reloadCart: true});
      let _context = {...context};
      _context.toast = {
        message: 'Added to Event Wait List!',
      }
      setContext({..._context});
    });
  };
  const preRegisterEvent = (event) => {
    let _e = {...event};
    _e.actionDate = new Date();
    setInventoryEvent(_e);

    if (event?.eventType?.memberOnly) {
      setShowPreRegister(true);
    } else {
      setShowRegister(true);
    }
  }

  const {confirm, ConfirmationDialog} = useConfirm();
  const [confirmation, setConfirmation] = useState(null);

  const registerMembershipEvent = async (event, memberAccount) => {

    if (event?.reservationStatus?.id > -1) {
      let _confirmation = {
        title: 'Registration',
        message: 'You are already registered for this event. Are you sure you wish to continue?'
      };
      setConfirmation(_confirmation);

      const ok = await confirm(_confirmation);
      if (!ok) {
        setConfirmation(null);
        return;
      }
    }

    let _event = {...event};
    _event.memberAccount = {...memberAccount};
    _event.actionDate = new Date();
    addToCart(_event).then((result) => {
      setCartContext({...cartContext, reloadCart: true, viewCart: true, caller: 'Register Add to cart fn'});
      setShowRegister(false);
      setShowPreRegister(false);
      setInventoryEvent(null);
      callback('close')
    });

  }

  const handleCloseRegisterEventModal = (refreshCart) => {
    setShowRegister(false);
    setShowPreRegister(false);
    if (refreshCart) {
      setCartContext({...cartContext, reloadCart: true, viewCart: true});
    }
  }

  const handleRefreshCart = () => {
    setCartContext({...cartContext, reloadCart: true, viewCart: true});
    handleCloseRegisterEventModal();
  }

  const eventRegistration = (event) => {
    return (<>

      {event?.reservationStatus?.id > -1 &&
        <p>
          <TipsAndUpdatesIcon/>
          &nbsp;You are already registered for this event</p>
      }

      {!validEvent(event, 'details') &&
        <>
          <MDButton variant="gradient"
                    size={'small'}
                    color="info"
                    disabled={true}
                    onClick={(e) => {
                    }}>Registration closed</MDButton>
        </>
      }
      {validEvent(event, 'event registration') && <div>
        <MDBox my={2}>
          {hideSessionRegistration(event) && showSessionChildRegistration(event) &&
            <>
              <MDTypography variant="p" className="mb-2"
              >This event is in a Session series.
              </MDTypography><br/>
              <MDButton variant="gradient"
                        size={'small'}
                        className="mt-2"
                        color="info"
                        onClick={(e) => {
                          viewParentSessionEvent(event.parentEventGuid);
                        }}>View Session Details</MDButton></>
          }

          {!hideTimeBlockRegistration(event) && !hideSessionRegistration(event) && <>
            {event.bookedFull &&
              <>
                <MDButton variant="gradient"
                          size={'small'}
                          color="info"
                          onClick={(e) => {
                            handleCloseCalendarEventDetail();
                            addToWaitlistFn(event);
                          }}>Join Wait List</MDButton>
              </>
            }
          </>}

          {!hideSessionRegistration(event) && <>
            {!event.bookedFull && <>
              {embedded && (full || !hideTimeBlockRegistration(event)) && event.memberAccountTypes?.length > 0 && <>
                {event.memberAccountTypes.map((_row, index) => {
                  return (<MDButton onClick={() => {
                    registerMembershipEvent(event, _row);
                  }}
                                    variant="gradient"
                                    sx={{'marginRight': '5px', 'marginBottom': '5px'}}
                                    size={'small'}
                                    key={index}
                                    color="info">
                    Register with {_row.name}
                  </MDButton>)
                })
                }
              </>}

              {(!full || showRegistration) && timeBlockEvent(event) && <div>

                <table>
                  <tbody>

                  {event.timeBlockEvents?.sort((e1, e2) => {
                    return new Date(e1.eventDate).getTime() - new Date(e2.eventDate).getTime()
                  })?.filter((event) => validEvent(event, 'time block picker'))?.map((tbe, idx) => {
                    return (
                      <tr key={idx} style={{
                        display: 'block !important',
                        width: '100%',
                        clear: 'both'
                      }} className={'d-block m-1'}>
                        <td>
                          {companyContext?.timeZone && <MDButton key={idx} size={'small'}
                                                                 disabled={tbe.bookedFull}
                                                                 color="primary"
                                                                 variant={"outlined"}
                                                                 onClick={(e) => {
                                                                   handleCloseCalendarEventDetail();
                                                                   let _tbe = {...tbe};
                                                                   _tbe.timeBlockParent = false;
                                                                   preRegisterEvent(_tbe);
                                                                 }}>
                            {displayEventTime(tbe, companyContext?.timeZone)}
                          </MDButton>
                          }
                        </td>
                      </tr>
                    )
                  })
                  }
                  </tbody>
                </table>
              </div>
              }

              {(!embedded || (!timeBlockEvent(event) && validEvent(event, "Single") && !event.memberAccountTypes?.length > 0)) && <>
                <MDButton variant="gradient"
                          size={'small'}
                          color="info"
                          disabled={embedded && event?.eventType?.memberOnly && (!loggedIn || !event.memberAccountTypes?.length > 0)}
                          onClick={(e) => {
                            handleCloseCalendarEventDetail();
                            preRegisterEvent(event);
                          }}>Register</MDButton>
              </>}
            </>
            }
          </>
          }
        </MDBox>
      </div>
      }
    </>)
  }

  return (
    <>
      {eventRegistration(event)}
      {viewCalendarEventDetail && <>
        <Modal onHide={handleCloseCalendarEventDetail} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay psb-overlay-medium'} show={viewCalendarEventDetail}>
          {!calendarEventDetail && <Modal.Body>
            <Loading/>
          </Modal.Body>}
          {calendarEventDetail &&
            <>
              <Modal.Header closeButton>
                <Modal.Title>{calendarEventDetail.name} Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EventDetail
                  showDesc={true}
                  event={calendarEventDetail}
                  packages={false}
                  full={true}
                  embedded={true}
                  callback={() => {
                  }}
                />
              </Modal.Body>
            </>
          }
        </Modal>
      </>}

      {
        inventoryEvent && <RegisterEventModal
          handleClose={(refreshCart) => {
            handleCloseRegisterEventModal(refreshCart)
          }}
          show={showRegister}
          event={inventoryEvent}
          refreshCart={handleRefreshCart}
        />
      }

      {
        inventoryEvent && <PreRegisterMemberOnlyEventModal
          handleClose={(refreshCart) => {
            handleCloseRegisterEventModal(refreshCart)
          }}
          show={showPreRegister}
          event={inventoryEvent}
          refreshCart={handleRefreshCart}
        />
      }

      {confirmation && <ConfirmationDialog/>}

    </>
  )
}